<template>
  <b-row>
    <b-col v-for="(role, index) in Object.keys(roles)" :key="'role_'+index">
      <b-form-checkbox
        v-model="roles[role]"
        :name="role"
        value="1"
        unchecked-value="0"
        disabled
      >
        {{ titles[index] }}
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Roles',
  props: {
    confAcl: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      clientTypeList: 'clienttype/list/items'
    })
  },

  data () {
    return {
      titles: [],
      roles: {}
    }
  },

  async created () {
    if (!this.clientTypeList.length) {
      await this.getClientTypes()
    }
    this.clientTypesHandler()
    this.pairRoles()
  },

  methods: {
    clientTypesHandler () {
      this.clientTypeList.forEach(clientType => {
        this.roles[clientType.roles[0]] = 0
        this.titles.push(clientType.title)
      })
    },
    pairRoles () {
      this.confAcl.role.forEach(role => {
        if (this.roles[role] === 0) this.roles[role] = 1
      })
      this.$forceUpdate()
    },
    ...mapActions({
      getClientTypes: 'clienttype/list/default'
    })
  }
}
</script>
